import React, { memo } from 'react'
import { usePopular, PopularProps } from './usePopular'
import styles from './Popular.module.scss'

const Popular: React.FC<PopularProps> = (props: PopularProps) => {
  const {} = usePopular(props)

  return <div className={styles.ribbon}>Popular</div>
}

export default memo(Popular)
